var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.5 62.8",
    style: {
      enableBackground: "new 0 0 269.5 62.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "103.4,0 99.8,0 82.4,26.1 87.9,26.1 101.6,5.1 115.1,26.1 120.6,26.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.3,26.1 154.3,0 149.4,0 149.4,10.4 128,10.4 128,0 123,0 123,26.1 128,26.1 128,14.2 149.3,14.2 149.3,26.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.7,7.9 177,26.1 181,26.1 194.3,7.8 194.3,26.1 198.9,26.1 198.9,0 194.7,0 179.2,21.3 163.7,0 159.1,0  159.1,26.1 163.7,26.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.6,22.2 208.6,22.2 208.6,14.2 229.5,14.2 229.5,10.4 208.6,10.4 208.6,3.9 230.6,3.9 230.6,0 203.7,0  203.7,26.1 230.6,26.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,18.7V7.7c0-5.2-2.3-7.7-9.7-7.7h-23.9v26.1h23.9C266.1,26.1,268.3,23.6,268.3,18.7z M239.7,3.9h19 c3.7,0,4.7,0.9,4.7,3.9v10.9c0,2.8-1,3.6-4.7,3.6h-19V3.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.2,40.5 94.9,40.5 94.9,62.8 99.9,62.8 99.9,40.5 113.2,40.5 113.2,36.6 81.2,36.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.7,36.6h-22.2v26.1h4.9V51.1h13.8l6.1,11.7h5.3L140.4,51c4.6-0.4,6.5-2.9,6.5-6.2V43C146.9,39.2,144.6,36.6,138.7,36.6 z M141.9,44.8c0,1.6-1,2.4-3.3,2.4h-17.3v-6.8h17.3c2.3,0,3.3,0.8,3.3,2.4V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,36.7h-17.3c-5.9,0-8.2,2.6-8.2,6.3v13.5c0,3.8,2.3,6.3,8.2,6.3l17.3,0c5.9,0,8.2-2.6,8.2-6.3V43 C184.3,39.2,182,36.7,176.1,36.7z M179.4,56.5c0,1.6-1,2.4-3.3,2.4h-17.3c-2.3,0-3.3-0.9-3.3-2.4V42.9c0-1.6,1-2.4,3.3-2.4h17.3 c2.3,0,3.3,0.8,3.3,2.4V56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5,56.5c0,1.6-1,2.4-3.3,2.4H197c-2.3,0-3.3-0.9-3.3-2.4V36.6h-4.9v19.8c0,3.8,2.3,6.3,8.2,6.3h17.3 c5.9,0,7.2-2.6,7.2-6.3V36.6h-4.9V56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,36.6h-23.9v26.1h23.9c7.4,0,9.6-2.6,9.6-7.5V44.4C259.8,39.2,257.5,36.6,250.1,36.6z M254.8,55.3 c0,2.8-1,3.6-4.7,3.6h-19V40.5h19c3.7,0,4.7,0.9,4.7,3.9V55.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.6,
    y: 36.6,
    width: 4.9,
    height: 26.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4,38.2C12.3,38.2,12.3,38.2,12.4,38.2C5.6,38.2,0,43.7,0,50.4c-0.1,7.2,6.6,12.5,12.4,12.2c0.2,0,0.3,0,0.5,0 c6.6-0.1,11.9-5.6,11.7-12.2C24.5,43.7,20,38.3,12.4,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,13.9h-3.3c-6.3,0-11.9-3.9-14.1-9.8l-0.3-0.9l-0.8-2.4C41.9,0.2,41.6,0,41,0H18.7c-0.8,0-0.8,0.1-0.5,1l20.4,60.3 c0.4,1.2,0.8,1.4,1.9,1.4c3.4,0,6.8,0,10.2,0c3.7,0,7.4,0,11.1,0c0.8,0,1.3,0,0.7-1.1L50.9,27.2H65L60.6,13.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.2df53ec13e6ec62e9d3847b03691a207.svg";
export { ForwardRef as ReactComponent };